import HtmlHead from "../components/headerAndFooter/HtmlHead";
import React from "react";
import {useWindowSize} from "../utils/Hooks";
import styled from "styled-components";
import {deviceMax} from "../../styles/device";
import {useAmp} from "next/amp";
import AdvertisementLayoutMobileComp from "../components/advertisement/AdvertisementLayoutMobileComp";
import AdvertisementLayoutDesktopComp from "../components/advertisement/AdvertisementLayoutDesktopComp";

export const config = {amp: 'hybrid'}

declare global {
    namespace JSX {
        interface IntrinsicElements {
            [elemName: string]: any;
        }
    }
}

declare module 'react' {
    interface StyleHTMLAttributes<T> extends React.HTMLAttributes<T> {
        jsx?: boolean;
        global?: boolean;
    }
}

type IProps = {
    source: any
    frontMatter: {
        backgroundImageUrl: string;
        breadcrumbs: string;
        formTitle: string;
        headTitle: string;
        description: string;
        propertyBottomContent: string;
        propertyBottomImg: string;
        propertyBottomTitle: string;
        propertyMiddleContent: string;
        propertyMiddleImg: string;
        propertyMiddleTitle: string;
        propertyTopContent: string;
        propertyTopImg: string;
        propertyTopTitle: string;
        saying: string;
    }
    noIndex?: boolean
}
export default function AdvertisementLayout(props: IProps) {

    const isAmp = useAmp();

    const windowSize = useWindowSize();

    return (
        <React.Fragment>
            <HtmlHead pageTitle={props.frontMatter.headTitle} description={props.frontMatter.description} noIndex={props.noIndex}/>
            <style jsx global>{`
              body, body.amp-mode-touch {
                font-family: 'Manrope', sans-serif;
                background-color: rgba(0, 0, 0, 0.04);
              }

              .advertisement-content-container {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                box-sizing: border-box;
                padding: 40px 24px 65px 24px;
                background: rgba(0, 0, 0, 0.03);
              }

              .advertisement-content-container > .advertisement-content-wrapper {
                position: relative;
                width: 100%;
                height: 100%;
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-gap: 100px;
                padding: 0 calc(50vw - 575px);
              }

              .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-img {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                padding: 100% 0 0 0;
                margin: 0 0 0 0;
                box-sizing: border-box;
              }

              .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-img img {
                width: 100%;
                height: 100%;
                -o-object-fit: cover;
                object-fit: cover;
                border-radius: 12px;
              }

              .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-text {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                padding: 0 0 0 0;
                margin: 0 0 0 0;
                box-sizing: border-box;
              }

              .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-text p {
                font-weight: 400;
                font-size: 18px;
                line-height: 30px;
                letter-spacing: 0;
                color: #000000;
                margin-bottom: 15px;
              }

              @media (max-width: 767px) {
                .advertisement-content-container > .advertisement-content-wrapper {
                  grid-template-columns: 1fr;
                  grid-gap: 0;
                  padding: 0;
                }
              }

            `}</style>
            <React.Fragment>
                {isAmp ? (
                    <React.Fragment>
                        <AdvertisementMobile>
                            <AdvertisementLayoutMobileComp source={props.source} frontMatter={props.frontMatter}/>
                        </AdvertisementMobile>
                        <AdvertisementDesktop>
                            <AdvertisementLayoutDesktopComp source={props.source} frontMatter={props.frontMatter}/>
                        </AdvertisementDesktop>
                    </React.Fragment>
                ) : (
                    windowSize.width < 768 ? (
                        <React.Fragment>
                            <AdvertisementLayoutMobileComp source={props.source} frontMatter={props.frontMatter}/>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <AdvertisementLayoutDesktopComp source={props.source} frontMatter={props.frontMatter}/>
                        </React.Fragment>
                    )
                )}
            </React.Fragment>

        </React.Fragment>
    );
}


const AdvertisementMobile = styled.div`
  display: none;

  @media ${deviceMax.tablet} {
    display: block;
  }
`;

const AdvertisementDesktop = styled.div`
  display: block;

  @media ${deviceMax.tablet} {
    display: none;
  }
`;
